function cov_1gd7bzijmr() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/PasswordlessResultPage.tsx";
  var hash = "3e1feaa463c93e454f4403e0cda65503cf97ff1b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/PasswordlessResultPage.tsx",
    statementMap: {
      "0": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 60,
          column: 1
        }
      },
      "1": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 59,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 23,
            column: 31
          },
          end: {
            line: 23,
            column: 32
          }
        },
        loc: {
          start: {
            line: 27,
            column: 35
          },
          end: {
            line: 60,
            column: 1
          }
        },
        line: 27
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 31,
            column: 9
          },
          end: {
            line: 31,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 31,
            column: 24
          },
          end: {
            line: 31,
            column: 43
          }
        }, {
          start: {
            line: 31,
            column: 46
          },
          end: {
            line: 31,
            column: 69
          }
        }],
        line: 31
      },
      "1": {
        loc: {
          start: {
            line: 34,
            column: 9
          },
          end: {
            line: 56,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 35,
            column: 10
          },
          end: {
            line: 41,
            column: 13
          }
        }, {
          start: {
            line: 43,
            column: 10
          },
          end: {
            line: 55,
            column: 13
          }
        }],
        line: 34
      }
    },
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "3e1feaa463c93e454f4403e0cda65503cf97ff1b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1gd7bzijmr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1gd7bzijmr();
import * as React from 'react';
import { Box, Link, Text } from '@opendoor/bricks-next';
import { t } from "../../i18n/translationHelper.mjs";
cov_1gd7bzijmr().s[0]++;
var PasswordlessResultPage = function PasswordlessResultPage(_ref) {
  var email = _ref.email,
    hasSucceeded = _ref.hasSucceeded,
    analyticsName = _ref.analyticsName;
  cov_1gd7bzijmr().f[0]++;
  cov_1gd7bzijmr().s[1]++;
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    py: "$36x",
    px: "$12x",
    gap: "$10x",
    $largerThanSM: {
      width: 480
    }
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h1",
    typography: "$headerMedium"
  }, hasSucceeded ? (cov_1gd7bzijmr().b[0][0]++, t('checkYourEmail')) : (cov_1gd7bzijmr().b[0][1]++, t('somethingWentWrong'))), /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    typography: "$bodySmall"
  }, hasSucceeded ? (cov_1gd7bzijmr().b[1][0]++, /*#__PURE__*/React.createElement(React.Fragment, null, t('weSentEmailTo'), ' ', /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    typography: "$bodySmall"
  }, email), ". ", t('includesSignInLink'))) : (cov_1gd7bzijmr().b[1][1]++, /*#__PURE__*/React.createElement(React.Fragment, null, t('unableToSendEmail'), ' ', /*#__PURE__*/React.createElement(Link, {
    typography: "$bodySmall",
    variant: "secondary",
    href: "mailto:contact@opendoor.com",
    "aria-label": null,
    analyticsName: "".concat(analyticsName, "-passwordless-error-contact-us")
  }, "contact@opendoor.com"), ' ', t('forSupport')))));
};
export default PasswordlessResultPage;
//# sourceMappingURL=PasswordlessResultPage.mjs.map